import { useSelector } from 'react-redux'

export const TotalResults = ({ className }) => {
  const items = useSelector((state) => state.items)

  return (
    <span className={`text-dark ${className}`}>
      {I18n.t('search.total_results')}: {items.prettyTotal}
    </span>
  )
}
